import Axios from "axios";

export class StaticConfigRepository {
    get(projectName: string) {
        return Axios.get(`/${projectName}.json?` + new Date().getTime())
            .then(({ data }) => {
                return data;
            });
    }
}